import { apiService } from './apiService';
import { CreateNoteData, PaginatedNotes, PatientNote, UpdateNoteData } from '../models/patientNote';
import { API_BASE_URL } from '../config/env';

export interface GetNotesOptions {
  page?: number;
  perpage?: number;
  pinned?: boolean;
  author?: number;
}

export const notesService = {
  getNotes: async (patientId: number, options: GetNotesOptions = {}): Promise<PaginatedNotes> => {
    const params = new URLSearchParams();
    if (options.page != null) params.set('page', String(options.page));
    if (options.perpage != null) params.set('perpage', String(options.perpage));
    if (options.pinned != null) params.set('pinned', String(options.pinned));
    if (options.author != null) params.set('author', String(options.author));
    const query = params.toString();
    const url = `${API_BASE_URL}/clinic/patient/${patientId}/notes/${query ? `?${query}` : ''}`;
    try {
      return await apiService.get(url);
    } catch (err) {
      console.error(`Error fetching notes for patient ${patientId}:`, err);
      throw err;
    }
  },

  createNote: async (patientId: number, data: CreateNoteData): Promise<PatientNote> => {
    try {
      return await apiService.post(`${API_BASE_URL}/clinic/patient/${patientId}/notes/`, data);
    } catch (err) {
      console.error(`Error creating note for patient ${patientId}:`, err);
      throw err;
    }
  },

  updateNote: async (patientId: number, noteId: number, data: UpdateNoteData): Promise<PatientNote> => {
    try {
      return await apiService.patch(`${API_BASE_URL}/clinic/patient/${patientId}/notes/${noteId}/`, data);
    } catch (err) {
      console.error(`Error updating note ${noteId} for patient ${patientId}:`, err);
      throw err;
    }
  },

  deleteNote: async (patientId: number, noteId: number): Promise<void> => {
    try {
      await apiService.delete(`${API_BASE_URL}/clinic/patient/${patientId}/notes/${noteId}/`);
    } catch (err) {
      console.error(`Error deleting note ${noteId} for patient ${patientId}:`, err);
      throw err;
    }
  },
};
